import { Pencil } from 'lucide-react';
import { IS_MAC } from '@/lib/utils';

function Kbd({ children }) {
  return (
    <kbd className="rounded border border-border border-b-2 bg-muted px-[5px] py-px font-mono text-[10px] font-bold text-foreground">
      {children}
    </kbd>
  );
}

/** First-open empty state (design 05): the pitch plus the summon-from-anywhere hint. */
function NotesEmptyState() {
  return (
    <div className="chat-pane-texture flex min-h-0 flex-1 flex-col items-center justify-center gap-1.5 border-t border-border px-7 text-center">
      <Pencil className="mb-1 size-[30px] text-muted-foreground opacity-60" strokeWidth={1.6} aria-hidden />
      <span className="text-sm font-bold">Your private scratchpad</span>
      <p className="m-0 text-xs leading-relaxed text-muted-foreground">
        Notes, to-dos and files. Only you can see them — on any device you sign in to.
      </p>
      <span className="mt-2 flex items-center gap-1 text-[11px] text-muted-foreground">
        {IS_MAC ? (
          <>
            <Kbd>⌘</Kbd>
            <Kbd>⇧</Kbd>
            <Kbd>N</Kbd>
          </>
        ) : (
          <>
            <Kbd>Ctrl</Kbd>
            <Kbd>Shift</Kbd>
            <Kbd>N</Kbd>
          </>
        )}
        <span className="ml-1">opens this from anywhere</span>
      </span>
    </div>
  );
}

export default NotesEmptyState;
